import {useQuery} from '@tanstack/react-query';

import {getLeagueSeasons, SPORT_CATEGORY_SLUGS} from '../api';
import {LeagueSeasonDTO} from '../api/types';

export const useGetLeagueSeasons = (
  categorySlug: string | undefined,
  leagueId: string | undefined,
) => {
  const slug = categorySlug?.toLowerCase();
  return useQuery<LeagueSeasonDTO[]>({
    queryKey: ['leagueSeasons', slug, leagueId],
    queryFn: () => getLeagueSeasons(slug!, leagueId!),
    enabled: !!slug && !!leagueId && SPORT_CATEGORY_SLUGS.includes(slug),
  });
};
